<script>
export default {
  name: "DepositReceiptPrint",

  data() {
    return {
      patientDeposits: [],
      patient: {},
      footerMessage: {},
    };
  },

  computed: {
    totalAmount() {
      if (!this.patientDeposits.length) return 0;

      return this.patientDeposits
        .map((pD) => parseFloat(pD.depositAmount))
        .reduce((sum, amt) => sum + amt);
    },
  },

  mounted() {
    this.$root.loading = true;
    Promise.allSettled([
      this.fetchDeposits(),
      this.fetchPatient(),
      this.fetchMessage(),
    ])
      .then(() => {
        this.$root.loading = false;
        setTimeout(() => {
          window.print();
        }, 250);
      })
      .catch(() => {
        this.$root.loading = false;
      });
  },

  methods: {
    fetchDeposits() {
      return this.$http
        .get(
          `Accounts/GetPatientDeposits?PatientId=${this.$route.query.PatientID}&VisitNo=${this.$route.query.VisitNo}`
        )
        .then((response) => {
          this.patientDeposits = response.data;
        })
        .catch(() => {});
    },

    fetchPatient() {
      const queryString = `?PatientID=${this.$route.query.PatientID}`;

      return this.$http
        .get(`PatientRegistration/GetSpecificPatient${queryString}`)
        .then((response) => {
          this.patient = response.data.length ? response.data[0] : {};
        })
        .catch(() => {});
    },

    fetchMessage() {
      let url = `MasterData/GetSpecificOrganizationMessageforGroup`;
      url += `?Group=Deposit Receipt`;

      return this.$http.get(url).then(({ data }) => {
        this.footerMessage = data.length ? data[0] : {};
      });
    },
  },
};
</script>
<template>
  <div class="flex flex-wrap">
    <tail-address-header></tail-address-header>
    <div class="w-full p-1 text-center my-3">
      <h5 class="font-medium text-base uppercase">Deposits Receipt</h5>
    </div>
    <div
      class="flex flex-row w-full my-2 border-t-2 border-b-2 border-gray-400 px-1"
    >
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">Name: {{ patient.names }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">MRN: {{ patient.patienT_ID }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">IP NO: {{ patient.ipfileno }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">OP NO: {{ patient.opfileno }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">VisitNO: {{ patient.visitNo }}</h5>
      </div>
    </div>
    <table class="table table-hover">
      <thead class="text-sm">
        <tr class="w-full flex">
          <th class="p-tiny flex-1">Receipt No</th>
          <th class="p-tiny flex-1">Trx Date</th>
          <th class="p-tiny flex-1">Amount</th>
          <th class="p-tiny flex-1">Memo</th>
        </tr>
      </thead>
      <tbody class="text-xs flex flex-col">
        <tr
          class="w-full flex"
          v-for="(patientDeposit, idx) in patientDeposits"
          :key="idx"
        >
          <td class="p-tiny flex-1">{{ patientDeposit.receiptNo }}</td>
          <td class="p-tiny flex-1">
            {{ patientDeposit.trxDate | dateFormat }}
          </td>
          <td class="p-tiny flex-1">
            {{ patientDeposit.depositAmount | numberFormat }}
          </td>
          <td class="p-tiny flex-1">{{ patientDeposit.trxMemo || `-` }}</td>
        </tr>
        <tr class="w-full flex">
          <th colspan="4" class="p-tiny flex-1 text-right">
            Total Amount: {{ totalAmount | numberFormat }}
          </th>
        </tr>
      </tbody>
    </table>
    <div class="w-full p-1 mt-1 text-center">
        <h5 class="font-medium text-sm italic">{{ footerMessage.message }}</h5>
    </div>
  </div>
</template>
